import { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import message from '@/libs/message'
import { UserValueType } from './types'
import addAssignMemberModalAtom from '@/recoil/addAssignMemberModal'
import { useCreateHealthClaimAutoAssignment } from '@/services/healthClaim/useCreateHealthClaimAutoAssignment'

const ModalAddTeamMemberHook = () => {
  const [userValue, setUserValue] = useState<UserValueType[]>([])
  const [disabledSave, setDisabledSave] = useState<boolean>(true)
  const [addAssignMemberModal, setAddAssignMemberModal] = useRecoilState(addAssignMemberModalAtom)

  const {
    isVisible,
    onOkFunction,
    okButtonProps,
    onCancelFunction: cancelFunction,
  } = addAssignMemberModal

  const {
    mutateAsync: createHealthClaimAutoAssignment,
    status: statusCreateHealthClaimAutoAssignment,
  } = useCreateHealthClaimAutoAssignment()

  const onCancelFunction = () => {
    if (cancelFunction) {
      cancelFunction()
    }
    setUserValue([])
    setAddAssignMemberModal({
      isVisible: false,
    })
  }

  const onSubmit = async () => {
    if (userValue.length > 0) {
      const users = userValue.map((user) => user.value)

      await createHealthClaimAutoAssignment({ backofficeUserIds: users })
        .then(() => {
          if (onOkFunction) onOkFunction()
          setUserValue([])
          setAddAssignMemberModal({ isVisible: false })
          message.success({ content: 'เพิ่มผู้ใช้งานสำเร็จ', duration: 10 })
        })
        .catch(() => {
          message.error('เพิ่มผู้ใช้งานไม่สำเร็จ')
        })
    }
  }

  const isLoadButton = statusCreateHealthClaimAutoAssignment === 'pending'

  const buttonProps = { ...okButtonProps, disabled: disabledSave, loading: isLoadButton }

  useEffect(() => {
    if (userValue.length > 0) {
      setDisabledSave(false)
    } else {
      setDisabledSave(true)
    }
  }, [userValue.length])

  return {
    isVisible,
    buttonProps,
    onSubmit,
    onCancelFunction,
    userValue,
    setUserValue,
  }
}

export default ModalAddTeamMemberHook
